import { SITE } from '@/data/site.ts';
import { asset } from '@/lib/paths.ts';

/**
 * Company logo component displaying logo mark and site name wordmark.
 */
export function Logo({ className }: { className?: string }) {
  return (
    <span className={`logo ${className ?? ''}`.trim()}>
      <div className="logo__box">
        <img
          src={asset('images/logo-icon.webp')}
          alt={SITE.name}
          draggable={false}
          className="logo__mark"
        />
      </div>
      <span className="logo__word">
        <span className="logo__word-base">Learn</span>
        <span className="logo__word-accent">AI</span>
      </span>
    </span>
  );
}
